var map = {
	"./atcoder.jpeg": "2456",
	"./azure-icon.svg": "2bd1",
	"./c-sharp.svg": "bd36",
	"./cv.svg": "4042",
	"./django.svg": "d031",
	"./flask.svg": "bde8",
	"./html-5.svg": "98b0",
	"./icon-rainbow.zip": "9b95",
	"./icon_040623.svg": "28bc",
	"./icon_042963.svg": "5c08",
	"./icooon-mono.zip": "b530",
	"./java.svg": "31a0",
	"./javascript.svg": "2458",
	"./logo_bk.svg": "53fb",
	"./nlp.svg": "7c3f",
	"./numpy.svg": "f1c4",
	"./ooj.png": "97ec",
	"./opencv.svg": "84cc",
	"./python.svg": "15f7",
	"./pytorch.svg": "5cb1",
	"./rails.svg": "7f10",
	"./ruby.svg": "0101",
	"./stock.svg": "2f62",
	"./toeic.jpeg": "c4a0",
	"./vue.svg": "0dcb",
	"./vuetifyjs.svg": "b536"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";